import SVGInline from 'components/SVGInline/SVGInline';
import { ButtonInner } from 'components/Buttons/Button/Button.css';
import { css } from 'styled-components';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import { LoaderContainer } from 'components/LoadingIndicator/LoadingIndicator.css';
import Button from 'components/Buttons/Button/Button';
import { fontBold } from 'style/styled-components/cssGlobalVariables';
import { FavoriteButton } from 'components/Buttons/FavoriteButton/FavoriteButton';
import { PictureWrapper } from 'components/Picture/Picture.css';
import { hexToRgba } from 'utils/fnColors';
import { withMetaDataGuard } from 'utils/fnMetaData';
import { buttonReset } from 'style/styled-components/cssButtonReset';

export const PageWrapper = styled.div`
    position: relative;
    background: var(--color-dark-background);

    ${LoaderContainer} {
        position: absolute;
        height: 100px;
        width: 100%;
        top: calc(50% - 50px);
        text-align: center;
    }
`;

const NavigationIcon = styled.button`
    ${buttonReset}
    cursor: pointer;

    &:hover {
        background: var(--color-dark-foreground-15);

        svg {
            color: var(--color-main-white);
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }
`;

export const BackButton = styled(NavigationIcon)`
    background: var(--color-dark-foreground-5);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 8px;
        height: 16px;
        margin-top: 2px;
        margin-left: -2px;
    }
`;

export const NavigationWrapper = styled.div`
    width: 100%;
    position: absolute;
    padding: 12px 16px;
    display: flex;
    top: 0;
    left: 0;
    z-index: 5;

    ${MQ(Breakpoints.s)} {
        padding: 12px 32px;
    }

    ${MQ(Breakpoints.m)} {
        top: 60px;
        padding: 12px 72px;
    }
`;

export const LabelMetaData = withMetaDataGuard(styled.span`
    font-size: 14px;
    color: ${(props) => hexToRgba(props.theme.brandedConfig.high_contrast, 0.7)};
    display: flex;
    align-items: center;
`);

export const ImdbIcon = styled(SVGInline)`
    display: inline-block;
    margin-right: 3px;
`;

export const StyledButton = styled(Button)<{ progress?: number; isPrimary?: boolean }>`
    float: left;
    min-width: auto;

    ${(props) =>
        props.isPrimary
            ? css`
                  ${ButtonInner} {
                      background: var(--color-primary);
                      &:not(.no-hover):hover {
                          background: var(--color-primary-hover);
                      }
                  }
              `
            : css`
                  ${ButtonInner} {
                      background: var(--color-neutral-dark-body-10);
                      border: 2px solid transparent;

                      &:not(.no-hover):hover {
                          background: var(--color-dark-body-20);
                          border: 2px solid transparent;
                      }
                  }
              `}

    ${ButtonInner} {
        @media screen and (max-width: 600px) {
            .SVGInline {
                margin: 0 4px 0 0 !important;
            }
        }

        ${(props) =>
            props.progress &&
            css`
                background: linear-gradient(
                    to right,
                    var(--color-dark-body-70) ${props.progress}%,
                    var(--color-light-background) ${props.progress}%
                );
                transition: all 0s;
                padding: 12px 18px;
                border: 0;

                &:hover {
                    border: 0;
                }
            `}
    }
`;

export const StyledSVGInline = styled(SVGInline)`
    display: inline-block;
    margin-right: 3px;
`;

export const StyledFavoriteButton = styled(FavoriteButton)`
    float: left;
    margin-right: 12px;
    font-family: ${fontBold};
`;

export const ResumeProgressIndicatorWrapper = styled.div``;

export const ChannelLogoWrapper = styled.div`
    position: relative;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ${MQ(Breakpoints.xs)} {
        justify-content: flex-start;
    }

    ${PictureWrapper} {
        height: auto;
        width: auto;
        order: 0;
        margin-bottom: 6px;

        picture {
            display: inline-block;
            height: 32px;

            img {
                object-fit: contain;
                width: auto;
            }
        }

        ${MQ(Breakpoints.s)} {
            order: 0;
        }
    }

    * {
        vertical-align: middle;
        display: inline-block;
    }
`;

export const HDLabel = styled.span`
    width: 24px;
    height: 16px;
    background: ${(props) => props.theme.brandedConfig.high_contrast};
    color: ${(props) => props.theme.brandedConfig.black_color};
    border-radius: 2px;
    line-height: 16px;
    margin-left: 8px;
    font-size: 12px;
    text-align: center;
    order: 1;
    font-family: ${fontBold};
`;

export const CloseButton = styled(NavigationIcon)`
    background: var(--color-dark-foreground-5);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;

    svg {
        display: block;
        width: 16px;
        height: 16px;
    }
`;
